export default {"src":"/_next/static/media/orange-profile.99a9142e.svg","height":18,"width":13,"blurWidth":0,"blurHeight":0};